import {createFundamentalType, registerFundamentalNode} from "#template/fundamental/factory"
import {JsonInfo} from "#template/interface-descriptors"
import {priorNodeClassChain} from "#template/versioning"
import {jsonMarker} from "#template/nodes/json/marker"

export {isJsonLikeNode, isJsonLikeNodeClass, isJsonLike, isJsonValue, jsonLike, jsonLikeMarker, jsonLikeNode} from "#template/nodes/json/marker"
export type {JsonLike, JsonLikeNode} from "#template/nodes/json/marker"

export const JsonFT = createFundamentalType({
    name: "Json",
    marker: jsonMarker,
    InfoClass: JsonInfo,
    icon: "far fa-brackets-curly",
})

// FT renamed `JSON` → `Json`; versionChain entries keep saved `JSON*` graphs deserializing.
@registerFundamentalNode(JsonFT, "Likes")
export class JsonLikes extends JsonFT.Likes {
    public override get definition() {
        return {...super.definition, versionChain: priorNodeClassChain("JSONLikes")}
    }
}

@registerFundamentalNode(JsonFT, "Switch")
export class JsonSwitch extends JsonFT.Switch {
    public override get definition() {
        return {...super.definition, versionChain: priorNodeClassChain("JSONSwitch")}
    }
}

@registerFundamentalNode(JsonFT, "Input")
export class JsonInput extends JsonFT.Input {
    public override get definition() {
        return {...super.definition, versionChain: priorNodeClassChain("JSONInput")}
    }
}

@registerFundamentalNode(JsonFT, "Output")
export class JsonOutput extends JsonFT.Output {
    public override get definition() {
        return {...super.definition, versionChain: priorNodeClassChain("JSONOutput")}
    }
}

@registerFundamentalNode(JsonFT, "Export")
export class JsonExport extends JsonFT.Export {
    public override get definition() {
        return {...super.definition, versionChain: priorNodeClassChain("JSONExport")}
    }
}
